// extracted by mini-css-extract-plugin
export default {"login_bg":"login_login_bg__9gG0b","login_submit":"login_login_submit__s+J2t"};